import React,{ChangeEvent,useState,useCallback,useEffect} from "react";
import { useLocation } from "react-router-dom";
import 'Assets/css/GameRate.css';
import UseLangLstQuery from "Apis/LangTxtInqApi";

const GameRateUi = ({gameMainPageInfoState}:any) => {
    const { data: langData }:any = UseLangLstQuery();
    const GameRateData = gameMainPageInfoState?.grd;

    if (!gameMainPageInfoState || !GameRateData) {
        return (
            <div className="gameRateContainer">
                <p>{langData && langData.COMM_MAIN_LOADING_00 || "로딩중..."}</p>
            </div>
        );
    }

    return (
        <>
            <div className="gameRateContainer">
                <div className="gameRateImageWrap">
                    <ul>
                        <li>
                            <img src={GameRateData?.gameAgeImgUrl} alt="Game Rate" />
                        </li>
                        {GameRateData?.gameRtngImgUrlLst.map((imgUrl:any,index:number)=>(
                            <li key={index}>
                                <img src={imgUrl} alt={`Rating ${index + 1}`} />
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="gameRateTableWrap">
                    <table className="gameRateTable">
                        <tbody>
                            <tr>
                                {/*<th>제명</th>*/}
                                <th>{langData && langData.GAME_GRD_GAME_NM_00 || "제명"}</th>
                                <td>{GameRateData?.gameNm}</td>
                                {/*<th>상호</th>*/}
                                <th>{langData && langData.GAME_GRD_CS_CMPNY_NM_00 || "상호"}</th>
                                <td>{GameRateData?.csCmpnyNm}</td>
                            </tr>
                            <tr>
                                {/*<th>이용등급</th>*/}
                                <th>{langData && langData.GAME_GRD_GAME_RTNG_00 || "이용등급"}</th>
                                {/*<td>12세 이용가</td>*/}
                                <td>{langData && langData.GAME_GRD_GAME_RTNG_AGE_12_00 || "12세 이용가"}</td>
                                {/*<th>등급분류번호</th>*/}
                                <th>{langData && langData.GAME_GRD_CLSF_NO_00 || "등급분류번호"}</th>
                                <td>{GameRateData?.clsfNo}</td>
                            </tr>
                            <tr>
                                {/*<th>등급분류일자</th>*/}
                                <th>{langData && langData.GAME_GRD_CLSF_DT_00 || "등급분류일자"}</th>
                                <td>{GameRateData?.clsfDt}</td>
                                {/*<th>제작업신고번호</th>*/}
                                <th>{langData && langData.GAME_GRD_PRO_RPR_NO_00 || "제작업신고번호"}</th>
                                <td>{GameRateData?.proRprNo}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="gameRateTriangle"></div>
            </div>
        </>
    )
}

export default GameRateUi;
